// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails";
import { StreamActions } from "@hotwired/turbo";
import * as ActiveStorage from "@rails/activestorage";

StreamActions.close_modal = function() {
  const modal = document.getElementById(this.getAttribute('target'))
  if (modal) $(modal).modal('hide')
};
import Rails from "@rails/ujs"
import * as bootstrap from "bootstrap"

import './plugins/jquery';

import './plugins/moment';
import './plugins/cookie_custom';

import * as Bootstrap from 'bootstrap';
import 'bootstrap-notify';

import 'select2/dist/js/select2.min';

import 'trix';
import '@rails/actiontext';
import './custom_functions/swal_function';
import './peaq/main';
import './peaq/wizard';

window.Turbo = Turbo;
window.Rails = Rails;
window.bootstrap = bootstrap;
ActiveStorage.start()
Rails.start()

import './controllers';

document.addEventListener('turbo:load', function () {
    $(document).find('input[autofocus]').focus();
    autofillName();
    initCookiesEu();
    reflowFloatThead();
    checkUserAgreed();
});

document.addEventListener('turbo:frame-load', function () {
    $(document).find('input[autofocus]').focus();
    reflowFloatThead();
});
